export enum InfoMessage {
  UnAssignMember = 'UnAssignMember',
  EligibleOffshore = 'EligibleOffshore',
  NotEligibleOffshore = 'NotEligibleOffshore'
}
